import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import Label16 from '../../../theme/labels/Label16';
import { useTranslation } from 'react-i18next';
import { HELP_BUTTON_CLICKED } from '../../../utils/clevertapEvents';
import { pushEvent } from '../../../utils/clevertapUtils';
import { webConfig } from '../../../webConfig';
import iconUrl from '../../../assets/help-icon.svg';
import { useLocation } from 'react-router-dom';
import { PATH } from '../../../routes';

const SUPPORT_URL = webConfig.givelifySupportUrl;

const helpButtonStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonStyles: {
            position: 'fixed',
            zIndex: 9,
            right: 64,
            bottom: 64,
            backgroundColor: '#73717F',
            borderRadius: 40,
            color: '#fff',
            padding: 14,
            display: 'flex',
            textDecoration: 'none',
            '& img': {
                marginRight: 14,
            },
            '& .text': {
                color: '#fff',
                marginRight: 6,
            },
            [theme.breakpoints.down('md')]: {
                paddingTop: 12,
                paddingBottom: 12,
                right: 32,
                bottom: 32,
            },
            [theme.breakpoints.down('xs')]: {
                paddingTop: 9,
                paddingBottom: 9,
                right: 16,
                bottom: 16,
            },
        },
    }),
);

const HelpButton: React.FC = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const helpText = t('labels.help');
    const { buttonStyles } = helpButtonStyles();
    const onClick = () => pushEvent(HELP_BUTTON_CLICKED);
    switch (location.pathname) {
        case PATH.SIGNUP.HOME:
        case PATH.SIGNUP.SUBMITTED:
        case PATH.SIGNUP.WELCOME:
            return null;
        default:
            break;
    }
    return (
        <a
            className={buttonStyles}
            href={SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            <img src={iconUrl} alt={helpText} title={helpText} />
            <Label16 className="text" isBold>
                {helpText}
            </Label16>
        </a>
    );
};

export default HelpButton;
